/* Imports */
import UserService from "@/services/user.service";
/* /Imports/ */

/* 
  Module: UsersTableModule
  Description: This module representing different actions with users.
*/
export const userTable = {
    /*
      Self-contained/reusable module.
    */
    namespaced: true,

    /*
      Default states in this module.
    */
    state: {
        usersData: null,
    },

    /*
      Define actions for separate different logic. 
    */
    actions: {
        /* 
         Call UserService class then dispatch all users action.
        */
        getAllUsers({ commit }) {
            return UserService.getAllUsers().then(
                (response) => {
                    commit("dataSuccess", response.users);
                    return Promise.resolve(response.users);
                }
            )
        },
    },

    /*
      Define mutations for separate different states. 
    */
    mutations: {
        /* 
          If data for all users is successfully obtained.
        */
        dataSuccess(state, usersData) {
            state.usersData = usersData;
        },
    }
};
